import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useGetDeleteUserStatus = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.user.can_delete],
    queryFn: () =>
      userService.canDeleteAccount().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
